import type { ComponentType, FC, PropsWithChildren } from "react";
import { Link, type To } from "react-router";
import { type SvgIconProps, Tooltip } from "@mui/material";
import cx from "classnames";

interface SidebarNavigationItemProps {
  title: string;
  isActive: boolean;
  to: To;
  Icon: ComponentType<SvgIconProps>;
  isCollapsed: boolean;
}

const SidebarNavigationItem: FC<PropsWithChildren<SidebarNavigationItemProps>> = ({
  title,
  to,
  Icon,
  isActive,
  isCollapsed,
}) => {
  return (
    <Tooltip
      placement="right"
      arrow
      disableInteractive
      title={isCollapsed ? title : undefined}
    >
      <Link
        to={to}
        prefetch="viewport"
        data-test-id="sidebar-navigation-item"
        data-ph-capture-attribute-nav={title.toLowerCase()}
        data-name={title.toLowerCase()}
        aria-selected={isActive}
        className={cx(
          "group/nav flex items-center gap-2 p-2 -m-2 rounded-sm no-underline! transition-none! whitespace-nowrap",
          {
            "bg-action-selected dark:bg-primary-dark hover:text-inherit! dark:text-shadow-2xs text-shadow-primary-dark":
              isActive,
            "mx-0": isCollapsed,
          }
        )}
      >
        <Icon
          color="action"
          className={cx(
            {
              "group-not-[&:hover]/nav:opacity-50": !isActive,
            },
            "group-hover/nav:opacity-100 transition-all duration-200 group-hover/nav:duration-75"
          )}
          sx={{ width: 20, height: 20, color: "currentColor" }}
        />
        <span
          className={cx("inline-block text-base", {
            "ml-6 opacity-0": isCollapsed,
          })}
        >
          {title}
        </span>
      </Link>
    </Tooltip>
  );
};

export default SidebarNavigationItem;
